import React, { FunctionComponent } from 'react';
import { IconProps } from '.';

const DifficultIcon: FunctionComponent<IconProps> = ({ size }) => (
  <svg width={size ? size : 24} height={size ? size : 24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18 20V10" stroke="#253746" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M12 20V4" stroke="#253746" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M6 20V14" stroke="#253746" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>

)

export default DifficultIcon;
